<button (click)="goBack()"
class="arrowColor mt-10"
><fa-icon
    [icon]="['fas', 'arrow-left']"
    size="lg"
  ></fa-icon><span class="backText"><b>{{'k000013' | translate }}</b></span></button>
